/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefits_SubtitleInputs */

const en_home_benefits_subtitle = /** @type {(inputs: Home_Benefits_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A complete protection ecosystem — supporting you before, during, and after every journey.`)
};

const fr_home_benefits_subtitle = /** @type {(inputs: Home_Benefits_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un écosystème de protection complet — vous soutenant avant, pendant et après chaque voyage.`)
};

/**
* | output |
* | --- |
* | "A complete protection ecosystem — supporting you before, during, and after every journey." |
*
* @param {Home_Benefits_SubtitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefits_subtitle = /** @type {((inputs?: Home_Benefits_SubtitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefits_SubtitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefits_subtitle(inputs)
	return fr_home_benefits_subtitle(inputs)
});